import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useWindowSize } from './useWindowSize';

const DEFAULT_ACTIVE_PAGE = 1;

export function usePagination({ updateQuery = true } = {}) {
  const { width } = useWindowSize();
  const [page, setPage] = useState(DEFAULT_ACTIVE_PAGE);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(null);
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    const queryPage = params.get('page');

    if (queryPage && updateQuery) {
      setPage(Number(queryPage));
    }
  }, []);

  useEffect(() => {
    const queryPerPage = params.get('perPage');

    if (width && !queryPerPage) {
      setComputedPerPage(width);
    } else if (width && queryPerPage && !updateQuery) {
      setComputedPerPage(width);
    } else if (width && queryPerPage && updateQuery) {
      setPerPage(Number(queryPerPage));
    }
  }, [width]);

  useEffect(() => {
    if (page && perPage && updateQuery) {
      params.set('page', page);
      params.set('perPage', perPage);
      setParams(params);
    }
  }, [page, perPage]);

  const setActivePage = (page) => setPage(page);

  const setComputedPerPage = (windowWidth) => {
    if (windowWidth <= 1400) {
      setPerPage(5);
    } else if (windowWidth > 1400 && windowWidth <= 1600) {
      setPerPage(10);
    } else if (windowWidth > 1600) {
      setPerPage(20);
    }
  };

  const setPagination = (pagination) => {
    setActivePage(pagination.current);
    setPerPage(pagination.pageSize);
  };

  const resetPagination = () => {
    setActivePage(DEFAULT_ACTIVE_PAGE);
    setTotalRows(0);

    if (!updateQuery) {
      setComputedPerPage(width);
    }
  };

  return {
    page,
    totalRows,
    perPage,
    setTotalRows,
    setPagination,
    resetPagination,
  };
}
